// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Resolvers
import { getCurrentOnboardingStateResolver } from '../resolvers/get-state.resolver';
// Types
import { AppStateContextType } from 'contexts/types/app.contexts.type';
import {
  GetStateBuilderHandlersType,
  GetStateMethodsHandlersType,
} from './types/get-state.handlers.type';
// Utilities
import {
  checkoutHasErrorOrIsNotLegit,
  onboardingHasBeenDeclinedByRisk,
} from './utils/get-state.handlers.utils';
import { navigateToCallbackUrl } from 'utils/app-callback-url.utils';

const getCurrentOnboardingCheckoutStateHandler = async ({
  setCurrentState,
  setError,
}: GetStateBuilderHandlersType): Promise<void> => {
  const [response, error] = await getCurrentOnboardingStateResolver();

  if (onboardingHasBeenDeclinedByRisk(response)) {
    navigateToCallbackUrl();
  } else {
    checkoutHasErrorOrIsNotLegit({ error, response })
      ? setError(AppErrorEnumeration.STATE_FAILED)
      : setCurrentState(response?.state as AppStateContextType);
  }
};

const GetStateHandlers = (props: GetStateBuilderHandlersType): GetStateMethodsHandlersType => ({
  handleGetCurrentOnboardingCheckoutState: () => getCurrentOnboardingCheckoutStateHandler(props),
});

export { GetStateHandlers };
